<template>
  <div class="indexBox bg" style="position: relative;">
    <img class="WLJY_logo" v-if="matchId == 219 || matchId == 220 || matchId == 221 || matchId == 222|| matchId == 223" src="https://mc.posedu.com.cn/myAll_Img/WLJY_logo.png" style="left: 4.375rem;
    top: 1.3rem;" />

    <img  :src="hostUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="hostUrl">
    <img  :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;right: 2.5rem;top: 2rem;" v-if="hostUrl && technicalSupportUrl">
    <img :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="!hostUrl && technicalSupportUrl">

    <div class="bigTitleBack bg">
      <div class="bigTitle">{{showName!=''?showName:myTitle+'打分'}}</div>
    </div>
    <div class="mainBox" :style="mytype==10?'flex-direction: column;margin-top: 1.8125rem;':''">
      <!-- 企业or专家 评委打分 -->
      <div class="left_main bg" v-if="mytype==3 || mytype==5">
        <div class="scoring_playerBox bg">{{studentObj.sort}}号选手</div>
        <div class="worksTitleBox bg">
          <div class="worksTitleBox_main" :style="scroll_bar?'':'justify-content: center;'">
            <span v-for="(item, index) in studentObj.creationNameTwo" :key="index">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="right_main bg" v-if="mytype==3 || mytype==5" :class="mytype==5?'right_mainTwo':''">
        <div class="right_main_title bg">
          <div class="right_main_title_text">
            {{showName!=''?showName+'情况':myTitle+'打分情况'}}
          </div>
        </div>
        <div class="scoringList"
          :class="enterprise.length>8?enterprise.length>10?'scoringListMax15':'scoringListMax10':''" v-if="mytype==5">
          <div class="scoringList_main"
            :class="enterprise.length>8?enterprise.length>10?'scoringList_mainMax15 scoringList_mainMax10':'scoringList_mainMax10':''"
            v-for="(item, index) in enterprise" :key="index">
            <div class="phone">
              <img v-if="item.photoUrl" :src="item.photoUrl" />
              <img v-else src="https://mc.posedu.com.cn/myAll_Img/Icon_one.png" />
            </div>
            <div class="scoringName">{{item.name}}</div>
            <div class="scoringNum"
              :style="(item.score==0 || item.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==1?'font-size:3rem;':''):'background: rgba(12, 58, 125, 0.7);'">
              {{(item.score==0 || item.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==0?'已评分':item.score):'正在评分...'}}
            </div>
          </div>
        </div>
        <div class="scoringList" :class="expert.length>8?expert.length>10?'scoringListMax15':'scoringListMax10':''"
          v-else-if="mytype==3">
          <div class="scoringList_main"
            :class="expert.length>8?expert.length>10?'scoringList_mainMax15 scoringList_mainMax10':'scoringList_mainMax10':''"
            v-for="(item, index) in expert" :key="index">
            <div class="phone">
              <img v-if="item.photoUrl" :src="item.photoUrl" />
              <img v-else src="https://mc.posedu.com.cn/myAll_Img/Icon_one.png" />
            </div>
            <div class="scoringName">{{item.name}}</div>
            <div class="scoringNum"
              :style="(item.score==0 || item.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==1?'font-size:3rem;':''):'background: rgba(12, 58, 125, 0.7);'">
              {{(item.score==0 || item.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==1 && totalScore && totalScore!='0.00'?item.score:'已评分'):'正在评分...'}}
            </div>
          </div>
        </div>
      </div>
      <!-- 大众评委打分 -->
      <div class="top_main bg" v-if="mytype==10">
        <div class="top_main_leftBox bg">{{studentObj.sort}}号选手</div>
        <div class="top_main_rightBox"><span>{{studentObj.creationName}}</span></div>
      </div>
      <div class="bottom_main bg" v-if="mytype==10">
        <div class="right_main_title bg">
          <div class="right_main_title_text">
            {{showName!=''?showName:myTitle+'打分情况'}}
          </div>
        </div>
        <div class="theMassesTable_Box">
          <!-- <div class="theMassesTable" v-if="theMasses.length>0"> -->
          <!-- :autoplay="false" -->
          <el-carousel height="100%" class="carousel" :interval="4000" arrow="never" indicator-position="none">
            <el-carousel-item v-for="(item,index) in theMasses" :key="index" class="carousel-item">
              <div class="carousel-item_son" v-for="(it_son, in_son) in item" :key="in_son">
                <div class="carousel-item_son_num">{{index * 28 + in_son + 1}}</div>
                <div class="carousel-item_son_name">
                  <div>{{it_son.name}}</div>
                </div>
                <div class="carousel-item_son_score"
                  :style="(it_son.score==0 || it_son.score ) || (totalScore && totalScore!='0.00')?'background-color:#41D959;':''">
                  {{(it_son.score==0 || it_son.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==0?'已评分':it_son.score):'正在评分'}}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- <div class="tdBox" v-for="(item, index) in theMasses" :key="index">
              <div>
                {{item.name}}
              </div>
              <span>{{(item.score==0 || item.score ) || (totalScore && totalScore!='0.00')?(showJudgesScore==0?'已评分':item.score):'正在评分'}}</span>
            </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_left_Decoration.png" />
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_right_Decoration.png" />
      <div class="Base_bottomBox bg">
        <div class="Base_bottomBox_title" style="font-size: 3.325rem;">
          <!-- :style="myTitle.length+4>7?'font-size: 2.125rem;':myTitle.length+4>6?'font-size: 2.525rem;':myTitle.length+4>5?'font-size: 2.8rem;':myTitle.length+4>4?'font-size: 3.125rem;':myTitle.length+4>3?'font-size: 3.325rem;':myTitle.length+4>2?'font-size: 4rem;':''" -->
          <!-- {{showName!=''?showName+'综合情况':myTitle+'打分综合情况'}} -->
          {{'选手得分'}}
        </div>
        <div class="totalScore">{{totalScore=='' || !totalScore?0:totalScore}}</div>
        <div class="numBox">
          <div v-if="countdown && countdown!='00:00'" :class="minute==0&& second<=10 && second>0 && suspend?'numRed numRed_animation':
            (minute==0 && second==0) || (minute==0 && second<=10 && !suspend)?'numRed':'num'">
            {{minute<10?'0'+minute:minute}}:{{second<10?'0'+second:second}}</div>
          <img class="lightDisk" v-if="countdown && countdown!='00:00'" src="https://mc.posedu.com.cn/myAll_Img/lightDisk.png" />
        </div>
      </div>
    </div>
    <audio id="myaudio" controls="controls" hidden src="https://mc.posedu.com.cn/myAll_Img/time_sound.mp3?1"
      ref="audio"></audio>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        showJudgesScore: 0, //是否开启展示评委打分
        countdown: '', //倒计时
        minute: '', //分钟
        second: '', //秒
        circulateFunTime: null,
        countdownGO_FunTime: null, // 倒计时函数
        playerId: 0, //选手id
        pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
          '/pages/countdown', '/pages/totalScore_player'
        ], //首页banner、选题、打分、排行、倒计时、总分
        matchId: 0,
        studentObj: {}, //选手信息
        totalScore: '', //总分
        expert: [], //专家评委
        enterprise: [], //企业评委
        theMasses: [], //大众评委
        mytype: 0, //环节
        myTitle: '',
        suspend: true, //倒计时是否进行中
        scroll_bar: false, //是否有滚动条
        hostUrl:'',
        technicalSupportUrl:'',
        showName:'',
      };
    },
    mounted() {
      this.matchId = this.$route.query.matchId;
      let that = this
      this.$get(
          "gerSecondConsoleInfo", '?trackId=' + 1, {
            matchId: this.matchId,
          }
        )
        .then((res) => {
          console.log('1214', res.data);
          this.mytype = res.data.type
          if (this.mytype == 5) {
            this.myTitle = '企业'
          } else if (this.mytype == 3) {
            this.myTitle = '专家'
          } else {
            this.myTitle = '大众'
          }
          this.playerId = res.data.playerId
          this.showJudgesScore = res.data.showJudgesScore
          this.countdown = res.data.countDownSeconds
          if (res.data.showName) {
            this.myTitle = this.showName = res.data.showName
          }
          this.minute = parseInt(this.countdown.split(':')[0])
          this.second = parseInt(this.countdown.split(':')[1])
          this.playerFun()
          setTimeout(() => {
            that.data_acquisition()
          }, 1000);
        })
        .catch((err) => {});

    this.hostUrl = sessionStorage.getItem('hostUrl')
    this.technicalSupportUrl = sessionStorage.getItem('technicalSupportUrl')
    },
    destroyed() {
      let that = this
      this.$refs.audio.pause(); //停止
      window.clearTimeout(that.circulateFunTime)
      window.clearInterval(that.countdownGO_FunTime)
    },
    methods: {
      // 倒计时
      countdownGO_Fun() {
        this.suspend = true
        let that = this
        //console.log("minute_second", this.minute, this.second);
        that.countdownGO_FunTime = window.setInterval(() => {
          if (that.second > 0) {
            that.second -= 1
            if (that.minute == 0 && that.second <= 10 && this.$store.state.audioShow == 1) {
              that.radioFun()
            }
          } else {
            if (that.minute > 0) {
              that.minute -= 1
              that.second = 59
              if (that.minute == 0 && that.second == 59 && this.$store.state.audioShow == 1) {
                that.radioFun()
              }
            } else {
              window.clearInterval(that.countdownGO_FunTime)
            }
          }
        }, 1000)
      },
      radioFun() {
        this.$refs.audio.currentTime = 0; //从头开始播放
        this.$refs.audio.play(); //播放
        setTimeout(() => {
          this.$refs.audio.pause(); //停止
        }, 800);
      },
      playerFun() {
        this.$get("playerPOST", this.playerId, {
            matchId: this.matchId,
          }).then((player_res) => {
            //console.log('选手信息', player_res.data);
            this.studentObj = player_res.data
            this.studentObj.creationNameTwo = player_res.data.creationName.split(" ")
            let that = this
            setTimeout(() => {
              let worksTitleBox_main = document.querySelector(".worksTitleBox_main")
              console.log("worksTitleBox_main", worksTitleBox_main.offsetHeight);
              if ((worksTitleBox_main.scrollHeight > worksTitleBox_main.clientHeight) || (worksTitleBox_main
                  .offsetHeight > worksTitleBox_main.clientHeight)) {
                // 有滚动条
                console.log("有滚动条");
                that.scroll_bar = true
              }
            }, 500);
          })
          .catch((err) => {});
      },
      data_acquisition() {
        this.$get("gerSecondConsoleInfo", '?trackId=' + 1, {
            matchId: this.matchId,
          }).then((res) => {
            sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
            if(res.data.currentScreenModal && res.data.currentScreenModal!=1){
              window.location.reload();
            }
            //console.log('gerSecondConsoleInfo', res.data);
            let that = this
            if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
              if (this.mytype == res.data.type && this.playerId == res.data.playerId) {
                if (res.data.countDownStatus == 0) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = res.data.countDownSeconds
                  this.minute = parseInt(this.countdown.split(':')[0])
                  this.second = parseInt(this.countdown.split(':')[1])
                } else if (res.data.countDownStatus == 1) {
                  if (this.minute == parseInt(this.countdown.split(':')[0]) && this.second == parseInt(this.countdown
                      .split(':')[1])) {
                    this.countdownGO_Fun()
                  }
                } else if (res.data.countDownStatus == 2) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = this.minute + ':' + this.second
                }
              } else {
                window.clearInterval(that.countdownGO_FunTime)
                this.mytype = res.data.type
                this.playerId = res.data.playerId
                this.countdown = res.data.countDownSeconds
                this.minute = parseInt(this.countdown.split(':')[0])
                this.second = parseInt(this.countdown.split(':')[1])
                this.playerFun()
              }
              this.circulateFunTime = window.setTimeout(() => {
                that.data_acquisition()
                that.getPlayerJudgesFun()
              }, 1000);
            } else {
              window.clearTimeout(that.circulateFunTime)
              let routerNum = null
              if (res.data.type == null) {
                routerNum = 0
              } else if (res.data.type == 4) {
                routerNum = 1
              } else if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
                routerNum = 2
              } else if (res.data.type == 9) {
                routerNum = 3
              } else if (res.data.type == 1 || res.data.type == 2 || res.data.type == 7) {
                routerNum = 4
              } else if (res.data.type == 6) {
                routerNum = 5
              }
              if (routerNum != null) {
                this.$router.push({
                  path: this.pagesArr[routerNum],
                  query: {
                    matchId: this.matchId,
                    soundOver: true
                  },
                });
              }
            }
          })
          .catch((err) => {});
      },
      getPlayerJudgesFun() {
        this.$post("getPlayerJudges", {
            matchId: this.matchId,
            playerId: this.playerId,
            type: this.mytype
          }, {
            matchId: this.matchId,
          }).then((res) => {
            //console.log('评委信息', res.data);
            this.totalScore = res.totalScore
            this.expert = res.data.pro
            this.enterprise = res.data.en
            // this.theMasses = res.data.dz
            this.theMasses = []
            for (let i = 0; i < res.data.dz.length;) {
              this.theMasses.push(res.data.dz.slice(i, i += 28));
            }
            // this.theMasses[0] = res.data.dz.slice(0, 28)
            // this.theMasses[1] = res.data.dz.slice(28, 56)
            // this.theMasses[2] = res.data.dz.slice(56, 84)
            // console.log("this.theMasses", this.theMasses);
          })
          .catch((err) => {});
      },
    }
  }

</script>
<style scoped>
  .bg {
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  * {
    padding: 0;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .indexBox {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-image: url(https://mc.posedu.com.cn/myAll_Img/backOne.png);
    overflow: hidden;
  }

  .bigTitleBack {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/bigTitle.png);
    font-size: 2.8125rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    width: 70.9375rem;
    height: 5rem;
    display: flex;
    justify-content: center;

  }

  .bigTitleBack .bigTitle {
    max-width: 27rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    color: #4997FE;
    background-image: -webkit-linear-gradient(top, #79CBFB, #4997FE);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .mainBox {
    width: calc(100% - 8.75rem);
    display: flex;
    justify-content: space-between;
    margin-top: 0.8125rem;
  }

  .mainBox .left_main {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/Base_left.png);
    width: 45%;
    height: 60vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7.9vh 0 5.35vh;
  }

  .mainBox .left_main .scoring_playerBox {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/scoring_playerBack.png);
    width: 35.4375rem;
    height: 8.1875rem;
    font-size: 2.75rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #A5F9F9;
    line-height: 1.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mainBox .left_main .worksTitleBox {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/worksTitleBack.png);
    width: 100%;
    height: calc(100% - 8.1875rem);
    font-size: 2rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 5.125rem;
    letter-spacing: 0.125rem;
    overflow-y: auto;
  }

  .worksTitleBox_main {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 55%;
    width: 85%;
    margin: 23% 0 0 10%;
    overflow-y: auto;
  }

  .mainBox .left_main .worksTitleBox span {
    width: 100%;
    line-height: 3rem;
    /* display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden; */
  }

  .mainBox .right_main {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/Base_right.png);
    width: calc(55% - 4.6875rem - 2.5rem);
    height: calc(73.25vh - 1.25rem);
    padding: 1.25rem 1.25rem 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .mainBox .right_mainTwo {
    justify-content: space-between;
  }

  .right_main_title {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/scoring_Bakc.png);
    width: 35.8125rem;
    height: 4.125rem;
    font-size: 1.5rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #343C6A;
    line-height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right_main_title_text {
    margin-top: -0.7rem;
    max-width: 22.5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }

  .top_main {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/theMassesTitleBack.png);
    width: calc(100% - 3.125rem);
    height: 6.6875rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 1.5625rem;
  }

  .top_main .top_main_leftBox {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/theMassesTitle.png);
    width: 16.3525rem;
    height: 3.9375rem;
    font-size: 2.75rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #A5F9F9;
    margin: 0 3.125rem 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top_main .top_main_rightBox {
    font-size: 2rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    width: calc(100% - 19.4775rem);
  }

  .top_main .top_main_rightBox span {
    width: 100%;
    display: -webkit-box;
    /*将对象转为弹性盒模型展示*/
    -webkit-box-orient: vertical;
    /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2;
    /*限制文本行数*/
    overflow: hidden;
    /*超出隐藏*/
  }

  .bottom_main {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/theMassesMainBakc.png);
    width: calc(100% - 13rem);
    min-height: 34.375rem;
    margin-top: 2.8125rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.4375rem 6.5rem 2.5rem;
  }

  .theMassesTable_Box {
    width: 100%;
    height: 43vh;
    /* overflow-y: auto; */
    padding: 0 1rem;
    margin-top: 0.9375rem;
  }

  .carousel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
  }



  .carousel-item {
    width: calc(100vw - 13rem - 8.75rem - 1rem);
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
  }

  .carousel-item_son {
    width: calc((100% - 9.9375rem) / 4);
    /* width: 16.375rem; */
    /* height: 2.3125rem; */
    height: calc((100% - 8.25rem) / 7);
    display: flex;
    align-items: center;
    /* margin-right: 3.3125rem; */
    margin-bottom: 1.375rem;
  }

  .carousel-item_son:nth-child(7n) {
    margin-bottom: 0rem;
  }

  .carousel-item_son:nth-child(22),
  .carousel-item_son:nth-child(23),
  .carousel-item_son:nth-child(24),
  .carousel-item_son:nth-child(25),
  .carousel-item_son:nth-child(26),
  .carousel-item_son:nth-child(27),
  .carousel-item_son:nth-child(28) {
    margin-right: 0;
  }

  .carousel-item_son_num {
    width: 15.74803149606299%;
    margin-right: 1.181102362204724%;
    border-radius: 1.25rem 0px 1.25rem 0px;
    background-color: rgba(13, 42, 182, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 1.25rem;
    border-color: rgba(27, 75, 156, 1);
  }

  .carousel-item_son_name {
    width: 42.1259842519685%;
    border-radius: 0px 0.625rem 0px 0.625rem;
    background-color: rgba(8, 21, 42, 1);
    color: #fff;
    font-size: 0.875rem;
    text-align: center;
    border-color: rgba(84, 151, 224, 1);
  }

  .carousel-item_son_score {
    width: 42.1259842519685%;
    border-radius: 0.625rem 0px 0.625rem 0px;
    background-color: #FF1600;
    color: #FFFFFF;
    font-size: 0.875rem;
    text-align: center;
    border-color: rgba(84, 151, 224, 1);
  }

  .carousel-item_son_num,
  .carousel-item_son_name,
  .carousel-item_son_score {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border: 0.0625rem solid rgba(27, 75, 156, 1);
  }

  .carousel-item_son_name div {
    max-width: calc(100% - 1rem);
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }

  /* .bottom_main .theMassesTable {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    border-left: 0.0625rem solid #0EF0EB;
    border-top: 0.0625rem solid #0EF0EB;
  }

  .bottom_main .theMassesTable .tdBox {
    height: 2.5rem;
    border-right: 0.0625rem solid #0EF0EB;
    border-bottom: 0.0625rem solid #0EF0EB;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.5rem;
    font-size: 1.625rem;
  }

  .bottom_main .theMassesTable .tdBox span {
    font-size: 1.125rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #A5F9F9;
    line-height: 1.125rem;
    width: 5.3rem;
  }

  .tdBox div {
    max-width: calc(100% - 5.5rem - 1.125rem);
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
    margin-left: 0.8125rem;
  } */

  .scoringList {
    height: calc(100% - 4.125rem);
    width: calc(100% - 3rem);
    padding: 0 1rem;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
  }

  ::-webkit-scrollbar {
    width: 0.6rem;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #2c6ff6;
    height: 0.5rem;
    width: 1.5rem;
    border-style: dashed;
    border-color: transparent;
    border-width: 0;
    border-radius: 0.6rem;
    background-clip: padding-box;
    -webkit-box-shadow: inset 0 0 0.25rem rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-track {
    background: #efefef;
    /* width: 1.6rem; */
    border-radius: 0.6rem;
  }

  .scoringListMax10 {
    height: calc(100% - 6.25rem);
  }

  .scoringListMax15 {
    height: calc(100% - 3.25rem);
  }

  .scoringList .scoringList_main {
    width: calc((100% - 3.75rem) / 4);
    height: calc(100% / 2 - 1.6875rem);
    background: rgba(255, 255, 255, 0.2);
    border-radius: 1.5rem 1.5rem 1.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 1.25rem 1.25rem 0;
  }

  .scoringList_mainMax10 {
    width: calc((100% - 5rem) / 5) !important;
  }

  .scoringList_mainMax15 {
    width: calc((100% - 5rem) / 5) !important;
    height: calc(100% / 3 - 1.6875rem) !important;
  }

  .scoringList_mainMax15 .phone {
    margin: 1vh 0 0.5rem !important;
  }

  .scoringList_mainMax15 .scoringNum {
    height: calc(100% - 7.6875rem - 1.5vh) !important;
    margin-top: 1.5vh !important;
  }

  .scoringList .scoringList_main:nth-child(4n) {
    margin: 0 0 1.25rem 0;
  }

  .scoringList .scoringList_mainMax10:nth-child(4n) {
    margin: 0 1.25rem 1.25rem 0 ;
  }

  .scoringList .scoringList_mainMax10:nth-child(5n) {
    margin: 0 0 1.25rem 0;
  }

  .scoringList .scoringList_main .phone {
    height: 8.125rem;
    width: 8.125rem;
    background: #ccc;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1rem 0 1.1875rem;
  }

  .scoringList .scoringList_main .phone img {
    width: 7.5rem;
    height: 7.5rem;
    border-radius: 50%;
  }

  .scoringList .scoringList_mainMax10 .phone {
    height: 5.125rem;
    width: 5.125rem;
    margin: 3vh 0 1.1875rem;
  }

  .scoringList .scoringList_mainMax10 .phone img {
    width: 4.6875rem;
    height: 4.6875rem;
  }

  .scoringList .scoringList_main .scoringName {
    font-size: 1.5rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.6rem;
    text-align: center;
  }

  .scoringList .scoringList_main .scoringNum {
    width: 100%;
    height: calc(100% - 12.875rem);
    margin-top: 1.0625rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #9CC9E1 0%, #70C0CD 100%);
    border-radius: 0 0 1.5rem 1.5rem;
    font-size: 1.5rem;
  }

  .scoringList .scoringList_mainMax10 .scoringNum {
    height: calc(100% - 7.6875rem - 5.5vh);
    margin-top: 2.5vh;
  }

  .bottomBox {
    margin-top: 1.25rem;
    width: calc(100% - 15.625rem);
    display: flex;
    justify-content: space-between;
  }

  .Base_bottomBox {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/Base_bottom.png);
    position: absolute;
    width: 62.1875rem;
    height: 9.3125rem;
    left: calc(50% - 31.09375rem);
    font-size: 4.125rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #A5F9F9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Base_bottomBox_title {
    max-width: 28.125rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    white-space: nowrap;
  }

  .totalScore {
    font-size: 7.5rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    color: #fff;
    line-height: 7.5rem;
    text-shadow: 0.0625rem 0.1875rem 0.5rem #1EF0ED;
    margin: 0 1.75rem 0 3.625rem;
  }

  .numBox {
    height: 6.5625rem;
    position: relative;
    width: 10.9375rem;
  }

  .numBox .num {
    font-size: 3.875rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    text-align: center;
    color: #1B6DC1;
    background: linear-gradient(180deg, #A5F9F9 0%, #1B6DC1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .numBox .numRed {
    font-size: 3.875rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    text-align: center;
    color: #FF0000;
    background: linear-gradient(180deg, #FB7474 0%, #FF0000 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .lightDisk {
    width: 10.9375rem;
    position: absolute;
    top: 0.4375rem;
    left: 0.75rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/scoring.vue